import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ArrayListService {
    constructor() {}

    groupBy(objects: Array<any>, key: string): Array<any> {
        if (objects?.length) {
            const reduce: Array<any> = objects.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
            return reduce;
        }
        return [];
    }

    private sortSimple(objects: Array<any>, descending: boolean): void {
        objects.sort((a: any, b: any) => {
            if (descending) {
                const t = a;
                a = b;
                b = t;
            }
            if (a < b) {
                return -1;
            } else if (a > b) {
                return 1;
            }
            return 0;
        });
    }

    private sortObject(objects: Array<any>, key: string, descending: boolean): void {
        objects.sort((a: any, b: any) => {
            if (descending) {
                const t = a;
                a = b;
                b = t;
            }
            if (a[key] < b[key]) {
                return -1;
            } else if (a[key] > b[key]) {
                return 1;
            }
            return 0;
        });
    }

    sortDescending(objects: Array<any>, key?: string): void {
        if (key) {
            this.sortObject(objects, key, true);
        } else {
            this.sortSimple(objects, true);
        }
    }

    sortAscending(objects: Array<any>, key?: string): void {
        if (key) {
            this.sortObject(objects, key, false);
        } else {
            this.sortSimple(objects, false);
        }
    }

    findIndexInArray(objects: Array<any>, object: any, property?: string): number {
        let index: number = -1;
        if (property) {
            index = objects.map((m) => m[property]).indexOf(object[property]);
        } else {
            index = objects.indexOf(object);
        }
        return index;
    }

    addIfNotExists(objects: Array<any>, object: any, property?: string): Array<any> {
        if (!objects) {
            return [object];
        }
        const index = this.findIndexInArray(objects, object, property);
        if (index === -1) {
            objects.push(object);
        }
        return objects;
    }

    removeIfExists(objects: Array<any>, object: any, property?: string): Array<any> {
        if (!objects) {
            return [];
        }
        const index: number = this.findIndexInArray(objects, object, property);
        if (index >= 0) {
            objects.splice(index, 1);
        }
        return objects;
    }
}
